import { render, staticRenderFns } from "./Certification.vue?vue&type=template&id=24df23ba&scoped=true";
import script from "./Certification.vue?vue&type=script&lang=js";
export * from "./Certification.vue?vue&type=script&lang=js";
import style0 from "./Certification.vue?vue&type=style&index=0&id=24df23ba&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "24df23ba", null);
export default component.exports;